import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IDialogContentComponent } from '../../modal-dialog/modal-dialog.service';

export interface CguInput {
}

export interface CguResult {
  accepted: boolean;
}

@Component({
  selector: 'app-cgu-popup',
  templateUrl: './cgu-popup.component.html',
  styleUrls: ['./cgu-popup.component.scss']
})
export class CguPopupComponent implements OnInit, IDialogContentComponent<CguResult, CguInput> {
  input?: CguInput;
  acceptedControl = new FormControl(false);

  ngOnInit(): void {
  }

  getResult(): CguResult {
    return { accepted: true };
  }

  isDisabled(): boolean {
    return !this.acceptedControl.value;
  }
}
